(() => {
 'use strict';
 const bind = root => {
  if (root.dataset.bound) return;
  root.dataset.bound = 'true';
  const track = root.querySelector('.at-gallery-track');
  const showMedia = id => {
   const target = document.getElementById(id);
   if (!target || !track) return;
   track.scrollTo({left: target.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
   root.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
  };
  root.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
  const select = root.querySelector('[name="id"]');
  const add = root.querySelector('[name="add"]');
  select?.addEventListener('change', () => {
   const choice = select.selectedOptions[0];
   root.querySelector('[data-at-price]').innerHTML = choice.dataset.price;
   root.querySelector('[data-at-checkout-price]').textContent = choice.dataset.checkoutPrice;
   const compare = root.querySelector('[data-at-compare]');
   compare.innerHTML = choice.dataset.compare;
   compare.hidden = choice.dataset.sale !== 'true';
   add.disabled = choice.dataset.available !== 'true';
   add.textContent = add.disabled ? add.dataset.soldLabel : add.dataset.addLabel;
   const url = new URL(location.href);
   url.searchParams.set('variant', choice.value);
   history.replaceState({}, '', url);
   showMedia(choice.dataset.media);
  });
 };
 const init = () => document.querySelectorAll('[data-at-product]').forEach(bind);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
 document.addEventListener('shopify:section:load', init);
})();
